module.exports = __webpack_public_path__ + "img/icbc.dc54f598.svg";